import Vue from 'vue'
import store from '@builder-web/Store'
import Router from 'vue-router'

import { GuestMiddleware, AuthMiddleware } from '@builder-web/Middlewares'

Vue.use(Router)

const router = new Router({
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        /**
         * Routes for guest pages
         */
        ...GuestMiddleware([
            {
                path: '/',
                name: 'home',
                component: () => import('@builder-web/Views/Login')
            },
            {
                path: '/login',
                name: 'login',
                component: () => import('@builder-web/Views/Login')
            },
            {
                path: '/register',
                name: 'register',
                component: () => import('@builder-web/Views/Register')
            },
            {
                path: '/forgot-password',
                name: 'forgotPassword',
                component: () => import('@builder-web/Views/ForgotPassword')
            },
            {
                path: '/reset-password/:token',
                name: 'resetPassword',
                component: () => import('@builder-web/Views/ResetPassword')
            },
            {
                path: '/verification/:token',
                name: 'verification',
                component: () => import('@builder-web/Views/Verification')
            },
        ]),

        /**
         * Routes for authenticated pages
         */
        ...AuthMiddleware([
            {
                path: '/profile',
                name: 'profile',
                component: () => import('@builder-web/Views/Profile')
            },
            {
                path: '/settings',
                name: 'settings',
                component: () => import('@builder-web/Views/Settings')
            },
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('@builder-web/Views/Dashboard')
            },
            /**
             * Job pages
             * @type {String}
             */
            {
                path: '/jobs',
                name: 'jobs',
                component: () => import('@builder-web/Views/Jobs/Jobs')
            },
            {
                path: '/jobs/create',
                name: 'jobs.create',
                component: () => import('@builder-web/Views/Jobs/Create')
            },
            {
                path: '/jobs/edit/:uuid',
                name: 'jobs.edit',
                component: () => import('@builder-web/Views/Jobs/Edit')
            },
            {
                path: '/jobs/:uuid',
                name: 'jobs.show',
                component: () => import('@builder-web/Views/Jobs/Job')
            },
            {
                path: '/jobs/:uuid/bids/winner',
                name: 'jobs.bid.winner',
                component: () => import('@builder-web/Views/Jobs/BidWinner')
            },

            /**
             * Message pages
             * @type {String}
             */
            {
                path: '/messages/chat',
                name: 'messages.chat',
                component: () => import('@builder-web/Views/Chat')
            },
            {
                path: '/messages/chat/:uuid',
                name: 'messages.chat.show',
                component: () => import('@builder-web/Views/Chat/Conversation')
            },
            /**
             * Supplier pages
             * @type {String}
             */
            {
                path: '/suppliers',
                name: 'suppliers',
                component: () => import('@builder-web/Views/Suppliers')
            },
            /**
             * Notifications pages
             * @type {String}
             */
            {
                path: '/notifications',
                name: 'notifications',
                component: () => import('@builder-web/Views/NotificationHistory')
            },
        ]),
    ]
})

router.beforeEach(async (to, from, next) => {
    if (store.getters['auth/token'] && !store.getters['auth/user']) {
        await store.dispatch('auth/fetchUser')
    }

    next()
})

export default router
